import step1 from '@sizeid/assets/pictograms/SVG/label-1-blue.svg';
import step2 from '@sizeid/assets/pictograms/SVG/label-2-blue.svg';
import step3 from '@sizeid/assets/pictograms/SVG/label-3-blue.svg';
import step4 from '@sizeid/assets/pictograms/SVG/label-4-blue.svg';

export default {
  step1,
  step2,
  step3,
  step4,
};
